//
//
//
//
//
//
//
//
//
//

export default {
    name: 'Tips',
    props: {
        text: {
            type: String,
            default: '线上报价的招标,请登录电脑端查看',
        },
    },
};
